import { useQuery } from '@tanstack/react-query';
import { CategoryParamTypes, fetchBundleCategories } from './apiFetchLanguageLearningBundlesCategories';

const LANGUAGE_LEARNING_BUNDLES_CATEGORIES_QUERY_KEY = 'languageLearningBundlesCategories';

export const useLanguageLearningBundlesCategories = ({ loanFormat, ageCategory }: CategoryParamTypes) => {
    return useQuery([LANGUAGE_LEARNING_BUNDLES_CATEGORIES_QUERY_KEY, { loanFormat, ageCategory }], () => {
        return fetchBundleCategories({ loanFormat, ageCategory });
    });
};
